import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SeatmapRowInt } from "@interfaces/*";
import { Passenger } from '@app/models/micro/passenger.model';
import { GlobalsService } from "@services/micro/globals.service";
import { PassengerService } from '@services/micro/passenger.service';
import { Reservation } from '@app/models/micro/reservation.model';
import { ApiService } from "@services/micro/api.service";
import { Router } from '@angular/router';
import { CartService } from "@services/micro/cart.service";
import { MessagesService } from "@services/messages.service";
import { TypesErrors } from "@enums/errors.enum";
import { Segment } from '@app/models/micro/segment.model';
import { SelectSeatComponent } from "@app/pages/seats/select-seat/select-seat.component";
import { Admin, FARES_FAMILY, SeatPassangerEstatus } from "@app/enums";
import { SeatsService } from "@services/seats.service";
import { ApiAncillaries } from '@app/services/micro/ancillaries.service';
import { messageNoCkn } from '@app/utils';
import { ResponseSeatInt } from '@app/interfaces/micro/ancillaries.interface';
import { messageParamsGeneric} from "@app/utils";
import { AdminService } from '@app/services/admin.service';
/**
  Componente Angular que gestiona la selección de asientos en un avión.
  Este componente permite a los pasajeros seleccionar asientos, verificar su disponibilidad,
  calcular costos asociados y manejar beneficios o restricciones relacionados con los asientos.
  También se encarga de actualizar el estado de los asientos y la información del pasajero en el servidor.
**/
@Component({
    selector: 'app-am-seat-plane',
    templateUrl: './am-seat-plane.component.html',
    styleUrls: ['./am-seat-plane.component.scss'],
    standalone: false
})
export class AmSeatPlaneComponent implements OnInit {
  @Input() seatDiv3: SeatmapRowInt
  rowsOfBlock: Array<any> = [];
  @Input() index
  @Input() classType
  @Input() airplane: string;
  @Input() id: string;
  selectedTrip: Segment;
  seatMap: any
  passengers: Array<Passenger> = [];
  status: number;
  type = ''
  name = ''
  cost = 0
  column = ''
  isSelected = false;
  row = ''
  reservation: Reservation;
  currentPassenger: Passenger
  seatDesc = '';
  segmentSelected: any;
  displayPassengerSelected: Passenger;
  indexSeat: number
  seatLast: any
  firstRows :any
  @ViewChild('popover-body', { static: true, read: ElementRef }) popover: ElementRef<HTMLElement>;

  benefits = [
    {
      path: '../../../../assets/images/Group1.svg'
    },
    {
      path: '../../../../assets/images/Group2.svg'
    },
    {
      path: '../../../../assets/images/Group3.svg'
    },
    {
      path: '../../../../assets/images/Vector1.svg'
    },
    {
      path: '../../../../assets/images/Vector2.svg'
    },
    {
      path: '../../../../assets/images/Vector3.svg'
    },
  ];

  constructor(
    private _passengerService: PassengerService,
    private _globalService: GlobalsService,
    private router: Router,
    private messages: MessagesService,
    private _seatService: SeatsService,
    private selectSeat: SelectSeatComponent,
    private _ancillaries: ApiAncillaries,
    private _admin: AdminService,
  ) {
    const pnrLookUp = this._globalService.getPNRLookup();
    this.seatMap = this._globalService.getSeatMapSegmet();
    this.passengers = this._passengerService.getPassengerSelection();
    this.reservation = pnrLookUp[0];
  }

  ngOnInit(): void {
    this.prepareComponent()
  }
  /**
    Prepara el componente cargando la información del asiento, el pasajero actual y el segmento seleccionado.
  **/
  prepareComponent() {
    this.selectedTrip = this._globalService.getSelectedTrip();
    this.currentPassenger = this._passengerService.getCurrentPassenger();
    this.segmentSelected = this.seatMap;
    this.name = this.seatDiv3.code;

    this.displayPassengerSelected = this.passengers.find(p =>
      p.seats.find((seat) => {
        return seat.segmentCode == this.selectedTrip.segmentCode && (seat.seatCode === this.seatDiv3.code || seat.code === this.seatDiv3.code);
      })
    );

    this.column = this.seatDiv3.column;
    this.row = this.seatDiv3.code?.replace(/\D/g, "");
    this.firstRows  = this.getFirstRowOfSections(this.seatMap.sectionInfo)
    const seat = this.segmentSelected.seatMap[this.name];

    if (this.displayPassengerSelected) {
      this.isSelected = true;
      this.status = 2
    }

    if (seat && seat?.currency && seat?.currency.base) {

      this.cost = seat.currency.total
      this.type = seat.seatType
      if (this.validateBenefit(seat)) {
        this.cost = 0
        this.segmentSelected.seatMap[this.name].currency2 = this.segmentSelected.seatMap[this.name].currency
        delete this.segmentSelected.seatMap[this.name].currency
      }

    }
    else if (seat.subjectToSeatSelectionFee) {
      this.segmentSelected.seatMap[this.name].currency = this.segmentSelected?.seatSelectionFee
      this.cost = this.segmentSelected?.seatSelectionFee.total;
      this.type = seat.seatType
    }
    else {
      this.cost = 0
    }
    if (seat?.status == 'UNAVAILABLE' || this._seatService.validateExitRowDisable(seat, this.currentPassenger)) {
      this.status = 2
    }
  }

  get disabledCostButton() {
    const admin = this._admin.admin;
    if (!admin?.Payment && this.cost > 0) {
      return true;
    }
    return false;
  }

  /**
    Valida y actualiza el costo del asiento seleccionado.
  **/

  validateCost() {
    let seatAsignated = this.generateSeatSelected();
    let seatName = '';

    const seat = this.currentPassenger.seats.find(seat => seat.segmentCode === this.selectedTrip.segmentCode);

    if (this.currentPassenger.seats.length > 0) {
      if (seat) {
        this.indexSeat = this.currentPassenger.seats.indexOf(seat);
        seatName = seat.seatCode;
        this.seatLast = seat;
      }
      if (this.indexSeat != undefined) {
        this.currentPassenger.seats[this.indexSeat] = seatAsignated
      } else {
        this.currentPassenger.seats.push(seatAsignated)
      }

    } else {
      this.currentPassenger.seats.push(seatAsignated)
    }

    this.handleSelectedSeat(seatAsignated, this.currentPassenger, seat);
  }

  /**
    Asigna la clase CSS correspondiente al tipo de asiento.
    @return Nombre de la clase CSS.
  **/

  asignateClass() {
    let nameClass = ''
    switch (this.classType) {
      case 'FIRST_CLASS':
        nameClass = 'premiermodal';
        this.seatDesc = 'seatReview.faresDesc.firstClass';
        break;
      case 'AM_PLUS':
        nameClass = 'amplusmodal';
        this.seatDesc = 'seatReview.faresDesc.amPlus';
        break;
      case 'PREFERRED':
        nameClass = 'preferredmodal';
        this.seatDesc = 'seatReview.faresDesc.amPreferred';
        break;
      case 'COACH':
        nameClass = 'coachgenmodal';
        this.seatDesc = 'seatReview.faresDesc.coach';
        break;
      case 'EXIT_ROW':
        nameClass = 'exitmodal';
        this.seatDesc = 'seatReview.faresDesc.exitRow';
    }
    return nameClass;
  }

  /**
    Genera un objeto con la información del asiento seleccionado.
    @return Objeto que representa el asiento seleccionado.
  **/

  generateSeatSelected() {
    let seat: any = {
      "_meta": this.segmentSelected.seatMap[this.name]?._meta || {},
      "code": this.segmentSelected.seatMap[this.name]?.code,
      "type": this.segmentSelected?.seatMap[this.name]?.seatType,
      "fareGa4": this.segmentSelected?.seatMap[this.name]?.seatType,
      "currency": null,
      "status": SeatPassangerEstatus.NO_ASSIGNED,
      "paidSeat": false,
      "paymentDue": false,
      "segmentCode": this.selectedTrip.segmentCode,
      "cost": null
    }

    if (this.segmentSelected.seatMap[this.name].currency != null) {
      seat.currency = this.segmentSelected.seatMap[this.name].currency

      if (this.segmentSelected.seatMap[this.name].currency.base) {
        seat.status = SeatPassangerEstatus.PENDING_PAYMENT;
        seat.cost = this.segmentSelected.seatMap[this.name].currency.total

        if (seat.cost == 0 || seat.cost == null) {
          seat.status = SeatPassangerEstatus.ASSIGNED;
        }
      }
    } else if (this.validateBenefit(seat)) {
      seat.status = SeatPassangerEstatus.BENEFIT;
      seat.currency = this.segmentSelected.seatMap[this.name].currency2
    }
    else {
      seat.subjectToSeatSelectionFee = null
    }

    return seat;
  }

  /**
     Realiza una solicitud a la API para actualizar la selección de asientos.
     @param seatSelected Asiento seleccionado para la solicitud.
     @param reservation Datos a enviar en la solicitud.
   **/
  handleSelectedSeat(seatSelected, currentPassenger: Passenger, seatOld) {
    this._ancillaries.setSeat(this.reservation,currentPassenger, seatSelected, seatOld).subscribe({
      next: (value: ResponseSeatInt[]) => {
        // if (!this.validateWarnings(value)) {
          // Encontrar el pasajero que tiene el asiento seleccionado
          this.displayPassengerSelected = this.passengers.find(p =>
              p.seats.find(seat =>
                seat.segmentCode === this.selectedTrip.segmentCode &&
                seat.code === seatSelected.code
              )
            );

          const positionCurrentPassenger = this._passengerService.getPositionCurrentPassenger();
          const nextPosition = positionCurrentPassenger + 1;
          this.isSelected = true;
          // Obtener el código del asiento asignado desde la respuesta
          const [ element ] = value;
          const [assignedSeat] = element.seats;
          const seatName = assignedSeat && assignedSeat.seatCode;

          const column = assignedSeat.seatCode.charAt(assignedSeat.seatCode.length - 1);
          const { cost, currency, isRedemptionCobrand, isRedemptionTier, paidSeat, status, type } = seatSelected;

          // Crear el objeto de asiento con la información de la respuesta
          const newSeat = Object.assign({}, assignedSeat, {
            airExtraItemNumber: assignedSeat.airExtraItemNumber,
            code: assignedSeat.code,
            column,
            cost: cost,
            currency: currency,
            endType: assignedSeat.endType,
            group: assignedSeat.group,
            isChangesSeat: assignedSeat.isChangesSeat,
            isRedemptionCobrand: isRedemptionCobrand || false,
            isRedemptionTier: isRedemptionTier || false,
            name: assignedSeat.name,
            owningCarrierCode: assignedSeat.owningCarrierCode,
            paidSeat: (currency?.total > 0 || (isRedemptionCobrand || isRedemptionTier)) ? false : paidSeat ? paidSeat : true,
            redemptionType: assignedSeat.redemptionType,
            rfic: assignedSeat.rfic,
            segmentIndicator: assignedSeat.segmentIndicator,
            ssrCode: assignedSeat.ssrCode,
            status: status,
            type: type,
            vendor: assignedSeat.vendor
          });

         
          this.currentPassenger = this._passengerService.getCurrentPassenger();
          // Agregar nuevo asiento al pasajero actual
          if(!this.currentPassenger.seatsNew) {
            this.currentPassenger.seatsNew = [];
          }

          const findIndex = this.getIndexLastSeat(this.currentPassenger.seatsNew);

          if (findIndex === -1) {
            // No existe asiento para este segmento, agregar nuevo
            this.currentPassenger.seatsNew.push(newSeat);
          } else {
            // Existe asiento para este segmento, actualizar el existente
            this.currentPassenger.seatsNew[findIndex] = newSeat;
          }

          // Actualiza el pasajero actual con la información modificada
          this._globalService.setPassenger(this.currentPassenger);

          if (this.passengers.length === nextPosition) {
            // Es el último pasajero, navegar a la siguiente pantalla
            this._passengerService.setPositionCurrentPassenger(0);
            this.router.navigate(['/seat']);
          } else {
            // Liberar el asiento anterior en el mapa de asientos (solo si existe)
            if (seatOld && seatOld.seatCode && seatOld.seatCode !== '') {
              this.segmentSelected.seatMap[seatOld?.seatCode].status = 'AVAILABLE';
              this.segmentSelected.seatMap[seatOld?.seatCode].statusNum = 1;
              this.segmentSelected.seatMap[seatOld?.seatCode].isSelect = false;
             // this._globalService.setSeatMapSegment(this.segmentSelected);
            }

            // Marcar el nuevo asiento como ocupado
            this.segmentSelected.seatMap[this.name].status = 'UNAVAILABLE';
            //this.segmentSelected.seatMap[this.name].isSelect = true;
            this.status = 2;
            this._globalService.setSeatMapSegment(this.segmentSelected);

            // SIEMPRE avanzar al siguiente pasajero (independiente de seatOld.seatCode)
            this._passengerService.setPositionCurrentPassenger(nextPosition);
            this.selectSeat.validateCheck(true);
            this.selectSeat.loadMapInit();

          }
        //}
      },
      error: error => {
        this.segmentSelected.seatMap[this.name].status = 'UNAVAILABLE'
        this.status = 2
        this.currentPassenger.seats[this.indexSeat] = this.seatLast
        //this.messages.error({ error }, error?.error?.code, '', messageParamsGeneric)
        this.messages.error(
          {
            typesError: TypesErrors.ERROR_IN_REMARK,
            error
          },
          null,
          TypesErrors.ERROR_IN_REMARK,
          messageParamsGeneric
        )
      },
      complete: () => {
        this.segmentSelected.seatMap[this.name].status = 'UNAVAILABLE';
        this.status = 2;
      }
    });
  }

  /**
   * Busca el índice de un asiento en el array seatsNew basado en el segmentCode del viaje actual.
   * @param seatsNew Array de asientos nuevos del pasajero
   * @returns Índice del asiento encontrado, o -1 si no existe
   */
  getIndexLastSeat(seatsNew) {
    const index = seatsNew.findIndex(seat => seat.segmentCode === this.selectedTrip.segmentCode);
    // Retornar -1 si no existe para poder distinguir entre "no existe" y "está en el índice 0"
    return index;
  }
/*   apiSeatSelect(seatName) {
    this._ancillaries.setSeat(this.reservation, seatName).subscribe({
      next: (value: any) => {
        if (!this.validateWarnings(value)) {
          this.displayPassengerSelected = this.passengers.find(p =>
            p.seats.find((seat) => {
              return seat.segmentCode == this.selectedTrip.segmentCode && seat.code === this.seatDiv3.code;
            }

            ))
          const positionCurrentPassenger = this._passengerService.getPositionCurrentPassenger();
          const nextPosition = positionCurrentPassenger + 1;
          this.isSelected = true;
          if (this.passengers.length == nextPosition) {
            this._passengerService.setPositionCurrentPassenger(0)
            this.router.navigate(['/seat'])
          } else {
            if (seatName != '') {
              this.segmentSelected.seatMap[seatName].status = 'AVAILABLE'
              this.segmentSelected.seatMap[seatName].statusNum = 1
              this.segmentSelected.seatMap[seatName].isSelect = false;
              this._globalService.setSeatMapSegment(this.segmentSelected)
            }
            this.segmentSelected.seatMap[this.name].status = 'UNAVAILABLE'
            this.status = 2
            this._passengerService.setPositionCurrentPassenger(nextPosition)
            this.selectSeat.validateCheck(true)
            this.selectSeat.loadMapInit()
            this.currentPassenger = this._passengerService.getCurrentPassenger();

          }
        }
      },
      error: err => {
        this.segmentSelected.seatMap[this.name].status = 'UNAVAILABLE'
        this.status = 2
        this.currentPassenger.seats[this.indexSeat] = this.seatLast
        this.getAlertWarning(err)
      },
      complete: () => {
        this.segmentSelected.seatMap[this.name].status = 'UNAVAILABLE'
        this.status = 2
      }
    });
  } */

  /**
    Valida si hay advertencias en la respuesta de la API.
    @param value Respuesta de la API.
    @return `true` si hay advertencias, `false` en caso contrario.
  **/

  validateWarnings(value) {
    if (value._warnings?._collection?.length > 0) {
      let [warning] = value._warnings._collection;
      this.segmentSelected.seatMap[this.name].status = 'UNAVAILABLE'
      this.status = 2
      this.getAlertWarning(warning)

      return true
    } else {
      return false
    }
  }
  /**
     Muestra una alerta de advertencia al usuario.
     @param warning Advertencia a mostrar.
   **/
  getAlertWarning(warning) {
    this.currentPassenger.seats[this.indexSeat] = this.seatLast
    this.messages.error({ error: warning }, warning.code, TypesErrors.SEAT_CHANGE_WARN, {
      showButton: true,
      buttonCopy: 'accept',
      colorFontButton: "white-font"
    }).finally(() => { });
  }
  /**
    Valida si el pasajero tiene beneficios aplicables al asiento.
    @return `true` si el pasajero tiene beneficios, `false` en caso contrario.
  **/
  validateBenefit(seat) {
    if (!seat) {
        return false;
    }

    const { fareFamily } =  this.reservation.flightSummary;
    const fareFamiliesAllow = [FARES_FAMILY.AMPLUS , FARES_FAMILY.PREFERRED,FARES_FAMILY.EXIT_ROW];
    const benefits = this.currentPassenger?.benefits || {} as any;
    const tierBenefits = benefits?.tierBenefits || {};
    const seats = tierBenefits?.seats || {};

    const {
        amPlus = false,
        preferent = false,
        exitRow = false,
        tourist = false
    } = seats;

    switch (seat?.seatType) {
        case 'AM_PLUS':
            return amPlus === true || fareFamiliesAllow.includes(fareFamily);
        case 'PREFERRED':
            return preferent === true || fareFamiliesAllow.includes(fareFamily);
        case 'EXIT_ROW':
            return exitRow === true || fareFamiliesAllow.includes(fareFamily);
        case 'COACH':
            return tourist === true;
        default:
            return false;
    }
  }
 getFirstRowOfSections(sections) {
  const firstRows: { sectionCode: string; firstRow: number; exitRows: number[] }[] = [];

  sections.forEach(section => {
    const rows = section.rows?._collection ?? section.rows ?? []; // por si no viene con _collection
    if (rows.length > 0) {
      // primera fila de la sección
      const firstRow = parseInt(rows[0].code, 10);

      // filas que son EXIT_ROW (excluyendo la primera fila)
      const exitRows = rows
        .filter(r =>
          r.seats?.some(
            (s: any) =>
              s.choice?.seatCharacteristics?.includes('EXIT_ROW') || // si viene así
              s.seatType === 'EXIT_ROW'                              // o si el tipo es EXIT_ROW
          )
        )
        .map(r => parseInt(r.code, 10))
        .filter(rowCode => rowCode !== firstRow);

      firstRows.push({
        sectionCode: section.code,
        firstRow,
        exitRows
      });
    }
  });

  return firstRows;
}


}


